<template>
  <div class="login-container">
    <el-form
      :model="ruleForm2"
      :rules="rules2"
      status-icon
      ref="ruleForm2"
      label-position="left"
      label-width="0px"
      class="demo-ruleForm login-page"
    >
      <h3 class="title">系统登录</h3>
      <el-form-item prop="username">
        <el-input
          type="text"
          v-model="ruleForm2.username"
          auto-complete="off"
          placeholder="用户名"
        ></el-input>
      </el-form-item>
      <el-form-item prop="password">
        <el-input
          type="password"
          v-model="ruleForm2.password"
          auto-complete="off"
          placeholder="密码"
        ></el-input>
      </el-form-item>
      <el-form-item style="width:100%;">
        <el-button
          type="primary"
          style="width:100%;"
          @click="handleSubmit"
          :loading="logining"
          >登录</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "Login",
  data() {
    return {
      logining: false,
      ruleForm2: {
        username: "",
        password: ""
      },
      rules2: {
        username: [
          { required: true, message: "请输入用户名", trigger: "blur" }
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }]
      }
    };
  },
  methods: {
    ...mapActions("user", ["login"]),
    handleSubmit() {
      this.$refs.ruleForm2.validate(valid => {
        if (valid) {
          this.logining = true;
          let data = {
            user: this.ruleForm2,
            successCallback: () => {
              this.$message.success("登陆成功");
              this.$router.push({ path: "/" });
            },
            errorCallback: error =>
              this.$message.error(`登陆失败 ${error.response.data.message}`)
          };
          this.login(data);
          this.logining = false;
        } else {
          this.$message.error("请检查输入是否正确");
          this.logining = false;
          return false;
        }
      });
    },
    enterSubmit() {
      document.onkeydown = e => {
        if (e.keyCode === 13 && e.target.baseURI.match("/login")) {
          this.handleSubmit();
        }
      };
    }
  },
  created() {
    this.enterSubmit();
  }
};
</script>

<style scoped>
.login-container {
  width: 100%;
  height: 100%;
}

.login-page {
  -webkit-border-radius: 5px;
  border-radius: 5px;
  margin: 250px auto;
  width: 350px;
  padding: 35px 35px 15px;
  background: #fff;
  border: 1px solid #eaeaea;
  box-shadow: 0 0 25px #cac6c6;
}
</style>
